<template>
  <div v-if="property" class="tw-pb-64 tw-pt-36">
    <library-container>
      <div class="tw-flex tw-flex-col">
        <div class="tw-flex tw-justify-between">
          <library-properties-back-to-all-properties-navbar />
        </div>
        <div class="mt-5 tw-flex tw-grid tw-grid-cols-12 tw-items-center">
          <div
            class="tw-col-span-12 tw-mb-4 tw-flex tw-flex-col tw-justify-center tw-gap-y-4 lg:tw-mb-0 lg:tw-gap-y-0 xl:tw-col-span-7"
          >
            <library-title tag="h1" class="tw-text-[26px]" :text="property.advert_heading"></library-title>
            <library-text class="tw-mt-2 tw-capitalize" :text="property.display_address"></library-text>
          </div>
          <div
            class="tw-col-span-12 tw-flex tw-flex-col tw-justify-between tw-gap-y-4 md:tw-col-span-5 md:tw-flex-row md:tw-items-center md:tw-gap-x-6 md:tw-gap-y-0"
          >
            <div v-if="property.price">
              <div class="tw-text-lg tw-capitalize">
                {{ property.price.type.name }}
              </div>
              <div class="tw-text-xl tw-font-bold">
                {{ property.price.price }}
              </div>
            </div>
            <div v-if="!property.is_locked" class="tw-flex tw-gap-x-4">
              <div class="tw-flex tw-items-center tw-gap-x-2">
                <div v-if="!isLetterPropertyCriteria" class="tw-order-1">
                  <svg width="26" height="27" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12.6673 13.8333V12.8333M3.33398 13.8333V12.8333"
                      stroke="#222222"
                      stroke-width="0.8"
                      stroke-linecap="round"
                    />
                    <path
                      d="M14.0007 8.49996C14.0007 5.98596 14.0007 4.72863 13.2193 3.94796C12.4387 3.16663 11.1813 3.16663 8.66732 3.16663H7.33398C4.81998 3.16663 3.56265 3.16663 2.78198 3.94796C2.00065 4.72863 2.00065 5.98596 2.00065 8.49996M1.33398 10.5C1.33398 9.87863 1.33398 9.56796 1.43532 9.32329C1.50233 9.16141 1.60058 9.01433 1.72447 8.89044C1.84835 8.76656 1.99544 8.6683 2.15732 8.60129C2.40198 8.49996 2.71265 8.49996 3.33398 8.49996H12.6673C13.2887 8.49996 13.5993 8.49996 13.844 8.60129C14.0059 8.6683 14.153 8.76656 14.2768 8.89044C14.4007 9.01433 14.499 9.16141 14.566 9.32329C14.6673 9.56796 14.6673 9.87863 14.6673 10.5C14.6673 11.1213 14.6673 11.432 14.566 11.6766C14.499 11.8385 14.4007 11.9856 14.2768 12.1095C14.153 12.2334 14.0059 12.3316 13.844 12.3986C13.5993 12.5 13.2887 12.5 12.6673 12.5H3.33398C2.71265 12.5 2.40198 12.5 2.15732 12.3986C1.99544 12.3316 1.84835 12.2334 1.72447 12.1095C1.60058 11.9856 1.50233 11.8385 1.43532 11.6766C1.33398 11.432 1.33398 11.1213 1.33398 10.5Z"
                      stroke="#222222"
                      stroke-width="0.8"
                    />
                    <path
                      d="M12.3346 8.49992V7.49992C12.3346 6.24259 12.3346 5.61459 11.944 5.22392C11.5533 4.83325 10.9253 4.83325 9.66797 4.83325H6.33464C5.0773 4.83325 4.4493 4.83325 4.05864 5.22392C3.66797 5.61459 3.66797 6.24259 3.66797 7.49992V8.49992M8.0013 5.16659V8.49992"
                      stroke="#222222"
                      stroke-width="0.8"
                    />
                  </svg>
                </div>
                <div v-else-if="isLetterPropertyCriteria" class="tw-order-2">BD</div>
                <div class="tw-text-xl" :class="isLetterPropertyCriteria ? 'tw-order-1' : 'tw-order-2'">
                  {{ property.bedroom }}
                </div>
              </div>
              <div class="tw-flex tw-items-center tw-gap-x-2">
                <div v-if="!isLetterPropertyCriteria" class="tw-order-1">
                  <svg width="26" height="27" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14 9.16667V11.1667C14 11.8739 13.719 12.5522 13.219 13.0523C12.7189 13.5524 12.0406 13.8333 11.3333 13.8333H4.66667C3.95942 13.8333 3.28115 13.5524 2.78105 13.0523C2.28095 12.5522 2 11.8739 2 11.1667V9.56667C2 9.46058 2.04214 9.35884 2.11716 9.28382C2.19217 9.20881 2.29391 9.16667 2.4 9.16667H14ZM14 9.16667V5.16667C14 4.45942 13.719 3.78115 13.219 3.28105C12.7189 2.78095 12.0406 2.5 11.3333 2.5H8M10.6667 13.8333L11.3333 15.1667M5.33333 13.8333L4.66667 15.1667"
                      stroke="black"
                      stroke-width="0.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.2663 5.83333H5.73294C5.51228 5.83333 5.33561 5.65467 5.35961 5.43467C5.45694 4.55 5.90828 2.5 7.99961 2.5C10.0909 2.5 10.5423 4.55 10.6396 5.43467C10.6636 5.65467 10.4869 5.83333 10.2663 5.83333Z"
                      stroke="black"
                      stroke-width="0.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div v-else-if="isLetterPropertyCriteria" class="tw-order-2">BA</div>
                <div class="tw-text-xl" :class="isLetterPropertyCriteria ? 'tw-order-1' : 'tw-order-2'">
                  {{ property.bathroom }}
                </div>
              </div>
              <div class="tw-flex tw-items-center tw-gap-x-2">
                <div v-if="!isLetterPropertyCriteria" class="tw-order-1">
                  <svg width="26" height="27" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5.93732 3.33337H10.064C10.6227 3.33337 10.9787 3.33337 11.2853 3.39404C11.8996 3.51623 12.4638 3.81782 12.9067 4.26068C13.3495 4.70354 13.6511 5.26778 13.7733 5.88204C13.82 6.11537 13.8307 6.37737 13.8333 6.73537C14.2174 6.84422 14.5556 7.07545 14.7963 7.39394C15.0371 7.71243 15.1673 8.10079 15.1673 8.50004V10.1294C15.1673 11.1494 14.6353 12.0454 13.834 12.554V13.1667C13.834 13.2993 13.7813 13.4265 13.6875 13.5203C13.5938 13.614 13.4666 13.6667 13.334 13.6667C13.2014 13.6667 13.0742 13.614 12.9804 13.5203C12.8867 13.4265 12.834 13.2993 12.834 13.1667V12.95C12.66 12.9834 12.4807 13 12.2967 13H3.70465C3.52065 13 3.34132 12.9827 3.16732 12.95V13.1667C3.16732 13.2993 3.11464 13.4265 3.02087 13.5203C2.9271 13.614 2.79993 13.6667 2.66732 13.6667C2.53471 13.6667 2.40753 13.614 2.31376 13.5203C2.22 13.4265 2.16732 13.2993 2.16732 13.1667V12.554C1.7587 12.2952 1.42218 11.9372 1.18906 11.5134C0.955936 11.0896 0.833791 10.6137 0.833985 10.13V8.50004C0.833985 7.66004 1.39798 6.95337 2.16798 6.73537C2.17065 6.37737 2.18132 6.11537 2.22798 5.88204C2.35017 5.26778 2.65177 4.70354 3.09463 4.26068C3.53749 3.81782 4.10172 3.51623 4.71598 3.39404C5.02265 3.33337 5.37865 3.33337 5.93732 3.33337ZM3.16865 6.73604C3.5523 6.84522 3.88989 7.0765 4.13026 7.39483C4.37063 7.71315 4.50066 8.10116 4.50065 8.50004V9.30004C4.50065 9.31871 4.51532 9.33337 4.53398 9.33337H11.4673C11.4762 9.33337 11.4846 9.32986 11.4909 9.32361C11.4971 9.31736 11.5007 9.30888 11.5007 9.30004V8.50004C11.5007 7.66137 12.064 6.95404 12.8327 6.73604C12.83 6.39604 12.8213 6.22271 12.7927 6.07737C12.7091 5.65698 12.5027 5.27081 12.1996 4.96773C11.8965 4.66465 11.5104 4.45827 11.09 4.37471C10.8927 4.33604 10.644 4.33337 10.0007 4.33337H6.00065C5.35732 4.33337 5.10865 4.33604 4.91132 4.37471C4.49092 4.45827 4.10476 4.66465 3.80168 4.96773C3.49859 5.27081 3.29222 5.65698 3.20865 6.07737C3.17998 6.22271 3.17132 6.39671 3.16865 6.73604ZM2.66732 7.66671C2.20732 7.66671 1.83398 8.04004 1.83398 8.50004V10.1294C1.83398 10.6255 2.03107 11.1013 2.38189 11.4521C2.73271 11.803 3.20852 12 3.70465 12H12.2967C12.7928 12 13.2686 11.803 13.6194 11.4521C13.9702 11.1013 14.1673 10.6255 14.1673 10.1294V8.50004C14.1673 8.27903 14.0795 8.06707 13.9232 7.91079C13.767 7.7545 13.555 7.66671 13.334 7.66671C13.113 7.66671 12.901 7.7545 12.7447 7.91079C12.5884 8.06707 12.5007 8.27903 12.5007 8.50004V9.30004C12.5007 9.5741 12.3918 9.83693 12.198 10.0307C12.0042 10.2245 11.7414 10.3334 11.4673 10.3334H4.53398C4.25993 10.3334 3.9971 10.2245 3.80331 10.0307C3.60952 9.83693 3.50065 9.5741 3.50065 9.30004V8.50004C3.50065 8.04004 3.12732 7.66671 2.66732 7.66671Z"
                      fill="black"
                    />
                  </svg>
                </div>
                <div v-else-if="isLetterPropertyCriteria" class="tw-order-2">RE</div>
                <div class="tw-text-xl" :class="isLetterPropertyCriteria ? 'tw-order-1' : 'tw-order-2'">
                  {{ property.reception }}
                </div>
              </div>
            </div>
            <div
              class="share-button tw-flex tw-w-2/5 tw-cursor-pointer tw-items-center tw-gap-x-3 tw-rounded tw-px-7 tw-py-5 md:tw-w-3/5 lg:tw-w-auto"
              @click="onShared()"
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M15 18.3333C14.3056 18.3333 13.7153 18.0903 13.2292 17.6042C12.7431 17.118 12.5 16.5278 12.5 15.8333C12.5 15.7361 12.5069 15.6353 12.5208 15.5308C12.5347 15.4264 12.5556 15.3328 12.5833 15.25L6.70833 11.8333C6.47222 12.0417 6.20833 12.205 5.91667 12.3233C5.625 12.4417 5.31944 12.5005 5 12.5C4.30556 12.5 3.71528 12.2569 3.22917 11.7708C2.74306 11.2847 2.5 10.6944 2.5 9.99999C2.5 9.30555 2.74306 8.71527 3.22917 8.22916C3.71528 7.74305 4.30556 7.49999 5 7.49999C5.31944 7.49999 5.625 7.55916 5.91667 7.67749C6.20833 7.79582 6.47222 7.95888 6.70833 8.16666L12.5833 4.74999C12.5556 4.66666 12.5347 4.57305 12.5208 4.46916C12.5069 4.36527 12.5 4.26443 12.5 4.16666C12.5 3.47221 12.7431 2.88193 13.2292 2.39582C13.7153 1.90971 14.3056 1.66666 15 1.66666C15.6944 1.66666 16.2847 1.90971 16.7708 2.39582C17.2569 2.88193 17.5 3.47221 17.5 4.16666C17.5 4.8611 17.2569 5.45138 16.7708 5.93749C16.2847 6.4236 15.6944 6.66666 15 6.66666C14.6806 6.66666 14.375 6.60777 14.0833 6.48999C13.7917 6.37221 13.5278 6.20888 13.2917 5.99999L7.41667 9.41666C7.44444 9.49999 7.46528 9.59388 7.47917 9.69832C7.49306 9.80277 7.5 9.90332 7.5 9.99999C7.5 10.0972 7.49306 10.198 7.47917 10.3025C7.46528 10.4069 7.44444 10.5005 7.41667 10.5833L13.2917 14C13.5278 13.7917 13.7917 13.6286 14.0833 13.5108C14.375 13.393 14.6806 13.3339 15 13.3333C15.6944 13.3333 16.2847 13.5764 16.7708 14.0625C17.2569 14.5486 17.5 15.1389 17.5 15.8333C17.5 16.5278 17.2569 17.118 16.7708 17.6042C16.2847 18.0903 15.6944 18.3333 15 18.3333Z"
                  fill="#222222"
                />
              </svg>
              <span class="tw-font-bold tw-uppercase"> Share </span>
            </div>
          </div>
        </div>
      </div>
    </library-container>
    <!-- GALLERY: START -->
    <div class="tw-mt-16 tw-grid tw-grid-cols-12 tw-gap-x-1">
      <div class="tw-relative tw-col-span-12 tw-w-full lg:tw-col-span-6" @click="onClickedImage(null)">
        <library-image
          :src="primaryFivePhotos[0].background"
          class="tw-rounded"
          @click="onClickedImage(primaryFivePhotos[0])"
          :blur="imageBlurFilter"
          :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
        ></library-image>
        <div v-if="isMobileDevice" class="photo-next">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
            <path fill="none" stroke="currentColor" stroke-width="2" d="m9 6l6 6l-6 6" />
          </svg>
        </div>
        <div v-if="isMobileDevice" class="photo-prev">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
            <path fill="none" stroke="currentColor" stroke-width="2" d="m15 6l-6 6l6 6" />
          </svg>
        </div>
        <div v-if="property.medias && property.medias.length" class="nc-first-image-overlay-item">
          <div v-if="property && property.medias" style="" class="tw-text-md tw-px-2 tw-py-1">
            1/{{ property.medias.length }}
          </div>
        </div>
      </div>
      <div v-if="!isMobileDevice" class="tw-col-span-12 tw-grid tw-grid-cols-12 tw-gap-x-1 md:tw-col-span-6">
        <div class="tw-col-span-6 tw-flex tw-flex-row tw-gap-y-1 md:tw-flex-col">
          <library-image
            :src="primaryFivePhotos[1].background"
            class="tw-rounded"
            @click="onClickedImage(primaryFivePhotos[1])"
            :blur="imageBlurFilter"
            :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
          ></library-image>

          <library-image
            v-if="primaryFivePhotos[2]"
            :src="primaryFivePhotos[2].background"
            class="tw-rounded"
            @click="onClickedImage(primaryFivePhotos[2])"
            :blur="imageBlurFilter"
            :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
          ></library-image>
        </div>
        <div class="tw-relative tw-col-span-6 tw-flex tw-flex-row tw-gap-y-1 md:tw-flex-col">
          <library-image
            v-if="primaryFivePhotos[3]"
            :src="primaryFivePhotos[3].background"
            class="tw-rounded"
            @click="onClickedImage(primaryFivePhotos[3])"
            :blur="imageBlurFilter"
            :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
          ></library-image>
          <library-image
            v-if="primaryFivePhotos[4]"
            :src="primaryFivePhotos[4].background"
            class="tw-rounded"
            @click="onClickedImage(primaryFivePhotos[4])"
            :blur="imageBlurFilter"
            :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
          ></library-image>
          <div
            v-if="primaryFivePhotos[4] && primaryFivePhotos[4].property_profile_media_id"
            class="nc-all-photos-button tw-cursor-pointer tw-uppercase"
            @click="onClickedImage(primaryFivePhotos[4])"
          >
            <library-text text="VIEW ALL PHOTOS" class="tw-text-xs tw-font-bold"></library-text>
          </div>
        </div>
      </div>
      <div v-if="isMobileDevice" class="tw-col-span-12 tw-mt-1 tw-grid tw-grid-cols-12 tw-gap-x-1">
        <div class="tw-col-span-6">
          <library-image
            v-if="primaryFivePhotos[1]"
            :src="primaryFivePhotos[1].background"
            class="tw-rounded"
            @click="onClickedImage(primaryFivePhotos[1])"
            :blur="imageBlurFilter"
            :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
          ></library-image>
        </div>
        <div class="tw-col-span-6">
          <library-image
            v-if="primaryFivePhotos[2]"
            :src="primaryFivePhotos[2].background"
            class="tw-rounded"
            @click="onClickedImage(primaryFivePhotos[2])"
            :blur="imageBlurFilter"
            :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
          ></library-image>
        </div>
      </div>
    </div>
    <!-- GALLERY: END -->
    <library-container v-if="!property.is_locked" class="tw-mt-20">
      <div class="tw-grid tw-grid-cols-12 md:tw-gap-x-10">
        <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-12 lg:tw-col-span-8">
          <!-- Property Video, Send Lead: START -->
          <property-detail-actions
            v-if="isMobileDevice"
            :property="property"
            :component="component"
            class="tw-col-span-12"
            @on-send-lead="onSendLead()"
          />
          <!-- Property Video, Send Lead: END -->

          <!-- FEATURES: START -->
          <div v-if="!property.is_locked" class="tw-flex tw-flex-col">
            <library-title text="Features" tag="h3"></library-title>
            <div class="tw-mt-4 tw-grid tw-grid-cols-12 tw-gap-x-3" ref="featuresGrid">
              <div
                v-for="(feature, index) in property.features"
                :key="`property-feature-${index}`"
                class="tw-col-span-12 tw-flex md:tw-col-span-6"
                :class="featuresBoxStyle === 1 ? 'tw-items-center' : ''"
                :style="[featuresBoxStyle === 2 ? `border-bottom: 1px solid var(--default-border-color)` : '']"
                style="padding-top: 15px; padding-bottom: 15px; height: auto"
              >
                <span v-if="featuresBoxStyle === 1" class="tw-pr-2">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9.5501 18L3.8501 12.3L5.2751 10.875L9.5501 15.15L18.7251 5.97498L20.1501 7.39998L9.5501 18Z"
                      fill="#BFA86C"
                    />
                  </svg>
                </span>
                <library-text class="feature-text tw-text-sm tw-font-semibold tw-uppercase" :text="feature">
                </library-text>
              </div>
            </div>
          </div>
          <!-- FEATURES: END -->
          <div v-if="!property.is_locked">
            <library-title text="Property Information" tag="h3"></library-title>
            <ul class="nav nav-tabs pxp-nav-tabs tw-mt-3">
              <li v-for="(tab, tabIndex) in tabs" :key="`tab-${tabIndex}`" class="nav-item">
                <div
                  :class="activeTab === tab.name ? 'active' : ''"
                  class="nav-link tw-cursor-pointer"
                  data-toggle="tab"
                  @click="activeTab = tab.name"
                >
                  {{ tab.title }}
                </div>
              </li>
            </ul>
            <div class="tab-content tw-mt-6">
              <div v-show="activeTab === 'description'" id="description" role="tabpanel">
                <div>
                  <div v-if="property.description">
                    <library-text class="tw-text-sm" :html="property.description"></library-text>
                  </div>
                </div>
              </div>
              <div v-show="activeTab === 'information'" id="information" role="tabpanel">
                <library-properties-property-criteria-list :property="property" :main-list-title="null">
                  <template #list-item="{ criteria }">
                    <library-title tag="h5" :text="criteria.title"></library-title>
                    <library-text class="tw-capitalize" :text="criteria.value"></library-text>
                  </template>
                </library-properties-property-criteria-list>
              </div>
              <div v-show="activeTab === 'video'" id="video" role="tabpanel">
                <div v-if="property?.featured_video">
                  <theme2-components-video-popup
                    :component="component"
                    :video-source="property.featured_video.mediaLink"
                  />
                </div>
              </div>
              <div v-show="activeTab === 'floor_plan'" id="floor_plan" role="tabpanel">
                <floor-plan :data="property.floor_plans" :component="component" />
              </div>
              <div v-show="activeTab === 'map'" id="map" role="tabpanel">
                <neuron-google-map
                  v-if="property.map_position && property.map_position.lat && property.map_position.lng"
                  v-model:map-center-position="property.map_position"
                  :component="component"
                  :marker-color="markerColor"
                />
              </div>
              <div v-show="activeTab === 'epc'" id="epc" role="tabpanel">
                <epc :data="property.epcs" :component="component" />
              </div>
            </div>
          </div>

          <library-tools-stamp-duty-calculator
            v-if="isMortgageCalculatorVisible && !property.is_locked"
            :default-price="property.price.numberPrice"
          />
          <library-tools-mortgage-calculator
            v-if="isStampDutyCalculatorVisible && !property.is_locked"
            :default-price="property.price.numberPrice"
          />
        </div>
        <!-- Property Video, Send Lead: START -->
        <div class="tw-col-span-12 lg:tw-col-span-4">
          <property-detail-actions
            v-if="!isMobileDevice"
            :property="property"
            :component="component"
            @on-send-lead="onSendLead()"
          />
          <div v-if="sidebarComponents && sidebarComponents.length" class="tw-mt-4">
            <available-components-for-sidebar
              key="property-detail-sidebar"
              key-prefix="property-detail-sidebar"
              :specific-components="sidebarComponents"
            />
          </div>
        </div>
        <!-- Property Video, Send Lead: END -->
      </div>
    </library-container>

    <library-container v-else-if="property.is_locked">
      <div class="tw-mt-10">
        <library-login />
      </div>
    </library-container>

    <full-screen-gallery
      v-if="fullScreenPopupConfig.is_active && activeMedia && property && property.medias && !property.is_locked"
      v-model:active-media-index="activeMediaIndex"
      :component="component"
      :active-media="activeMedia"
      :count-of-medias="property.medias.length"
      @close="closeLightbox()"
    />

    <popup v-if="!property.is_locked" :config="sendLeadPopupConfig" custom-width="800px">
      <template #content>
        <send-lead
          v-if="sendLeadPopupConfig.isActive"
          :property="property"
          @on-success="onSuccess"
          @close="sendLeadPopupConfig.isActive = false"
        />
      </template>
    </popup>
    <popup v-if="!property.is_locked" :config="successModalConfig" @close="onSuccessModalClosed()">
      <template #content>
        <success :text="successPopupText" />
      </template>
    </popup>
  </div>
</template>

<script lang="ts">
import { mapActions } from 'pinia';
import { ROUTES } from '~/constants/ui.constants';
import { usePropertiesStore } from '~/units/properties/stores';
import type { Component } from '~/types';
import { ComponentMixin } from '~/mixins/component.mixin';
import { PropertyMixin } from '~/units/properties/mixins/property.mixin';
import FloorPlan from '~/components/common/FloorPlan.vue';
import NeuronGoogleMap from '~/components/common/NeuronGoogleMap.vue';
import Epc from '~/components/common/Epc.vue';
import NcSelect from '~/components/common/inputs/NcSelect.vue';
import NcInput from '~/components/common/inputs/NcInput.vue';
import NcButton from '~/components/common/inputs/NcButton.vue';
import FullScreenGallery from '~/components/common/FullScreenGallery.vue';
import { useCoreStore } from '~/units/core/store';
import SendLead from '~/components/common/leads/SendLead.vue';
import Success from '~/components/common/popup/Success.vue';
import Popup from '~/components/common/popup/Popup.vue';
import PropertyDetailActions from '~/components/theme3/properties/PropertyDetailActions.vue';
import AvailableComponentsForSidebar from '~/components/theme3/AvailableComponentsForSidebar.vue';
import { getImagesByCount } from '~/units/properties/store';

export default defineNuxtComponent({
  name: 'Theme3PropertyDetail',
  components: {
    AvailableComponentsForSidebar,
    PropertyDetailActions,
    Popup,
    Success,
    SendLead,
    FullScreenGallery,
    NcButton,
    NcInput,
    NcSelect,
    Epc,
    NeuronGoogleMap,
    FloorPlan,
  },

  mixins: [ComponentMixin, PropertyMixin],

  data() {
    return {
      activeTab: 'description',
    };
  },

  computed: {
    tabs() {
      const tabs = [
        {
          name: 'description',
          title: 'Description',
          is_visible: true,
        },
        {
          name: 'information',
          title: 'Information',
          is_visible: true,
        },
        {
          name: 'video',
          title: 'Video',
          is_visible: !!this.property?.featured_video,
        },
        {
          name: 'floor_plan',
          title: 'Floor Plan',
          is_visible: !!this.property?.floor_plans?.length,
        },
        {
          name: 'map',
          title: 'Map',
          is_visible: true,
        },
        {
          name: 'epc',
          title: 'EPC',
          is_visible: !!this.property?.epcs?.length,
        },
      ];

      return tabs.filter((i) => i.is_visible);
    },

    imageBlurFilter() {
      if (this.property?.is_locked) {
        return '12px';
      }
      return undefined;
    },

    featuresBoxStyle() {
      if (this.vars.featuresStyleNumber) {
        return this.vars.featuresStyleNumber;
      }
      return 1; // b;
    },

    markerColor() {
      return this.colors.purple;
    },

    ROUTES() {
      return ROUTES;
    },

    primaryFivePhotos() {
      if (this.property) {
        return getImagesByCount(this.property, 5);
      }
      return [];
    },

    sidebarComponents(): Component[] {
      if (this.currentPage && this.currentPage.sidebar) {
        return this.currentPage.sidebar;
      }
      return [];
    },

    isMortgageCalculatorVisible() {
      return !this.vars.isMortgageCalculatorHiddenNumber;
    },

    isStampDutyCalculatorVisible() {
      return !this.vars.isStampDutyCalculatorHiddenNumber;
    },

    isLetterPropertyCriteria() {
      return this.vars.isLetterPropertyCriteriaNumber;
    },
  },

  methods: {
    ...mapActions(useCoreStore, ['shareApi', 'openTab']),

    async onShared() {
      await this.shareApi({
        title: this.property?.advert_heading,
        text: this.property?.advert_heading,
        url: window.location.href,
      });
    },
  },

  async setup(props: { component: Component }) {
    const store = usePropertiesStore();
    await store.fetchSingleProperty(props.component);
  },

  mounted() {},
});
</script>

<style scoped>
.share-button {
  border: 2px solid var(--camel);
}

.nav-link.active {
  color: var(--purple);
  border-bottom-color: var(--purple);
}

.nav-link {
  color: var(--black);
  font-size: 16px;
}

.nc-first-image-overlay-item {
  position: absolute;
  bottom: 0.1rem;
  right: 0.1rem;
  transform: translate(-50%, -50%);
  text-align: right;
  background-color: var(--white);
  color: var(--nc-classic-black);
  border-radius: 4px;
}

.nc-all-photos-button {
  position: absolute;
  bottom: 20px;
  left: 70px;
  padding: 10px;
  border-radius: 4px;
  background-color: var(--white);
  color: var(--nc-classic-black);
}

.photo-next,
.photo-prev {
  position: absolute;
  top: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 50px;
  height: 50px;
  background-color: #fff;
  border-radius: 50%;
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  cursor: pointer;
  font-size: 26px;
}

.photo-next {
  right: 5%;
}

.photo-prev {
  left: 5%;
}
</style>
